import type {SpecieRepository} from '@/domain/interfaces/SpecieRepository';

export class GetAllSpeciesUseCase {
  constructor(private readonly repository: SpecieRepository) {}
  async execute() {
    return this.repository.getAll();
  }
}
